import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonGroup, Button, CardActions, IconButton } from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { Avatar } from 'antd';
import CircularProgress from '@mui/material/CircularProgress';
import Icon from '@mdi/react';
import {
    mdiDelete, mdiFilePdfBox, mdiMicrosoftExcel,
    mdiEmailArrowRight, mdiEye, mdiCloseOctagon
} from '@mdi/js';
import { reportDetailViewSelector, setReportDetailView, downloadReport } from '../../features/datacenter/reportSlice';
import { deleteReport, getExcel, getPdf, } from '../../features/datacenter/datacenterApi';
import { assetNamesSelector } from '../../features/assets/assetsSlice';
import { setNeedBounding } from '../../features/map/mapSlice';
import GetPdfForm from '../common/GetPdfForm';



const ReportListItem = ({ reportID }) => {

    const dispatch = useDispatch();
    const reportData = useSelector(state => state.reports.reportData[reportID]);
    const reportDetailView = useSelector(reportDetailViewSelector);
    const reportIsDetailView = reportID === reportDetailView;

    const assetNames = useSelector(assetNamesSelector);
    const icon = assetNames && reportData.reqBody && assetNames[reportData.reqBody.imei] && assetNames[reportData.reqBody.imei].icon;

    useEffect(() => {
        removeTrackDetailViewCallback();
        return () => {
            removeTrackDetailViewCallback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (reportData) {
            console.log("Report Data", reportID, reportData.reportID, reportData);
        } else {
            console.log("Reportdata aint ready", reportID);
        }
    }, [reportData, reportID])

    const deleteTrackCallback = () => {
        if (reportDetailView === reportID) {
            dispatch(setReportDetailView(null));
        }
        dispatch(deleteReport(reportID));
    }

    const setTrackDetailviewCallback = () => {
        if (!reportData.dataTable) {
            //console.log("Getting reportdata");
            dispatch(downloadReport(reportID));
        }
        dispatch(setReportDetailView(reportID));
        dispatch(setNeedBounding(true));
    };

    const removeTrackDetailViewCallback = () => {
        dispatch(setReportDetailView(null));
    }

    const [getPdfFormOpen, setgetPdfFormOpen] = useState(false);
    const handleGetPdfFormClose = () => {
        setgetPdfFormOpen(false);
    }

    if (reportData && reportData.reqBody) {
        return (
            <div>
                <Card
                    style={{
                        backgroundColor: reportIsDetailView ? 'WhiteSmoke' : 'White',
                        marginBottom: '2px',
                    }}

                >
                    <CardHeader
                        avatar={
                            <Avatar style={{ backgroundColor: 'white' }}>
                                <img alt="a" src={icon ? `/assets/markers/def30/${icon}` : `/assets/markers/def30/cargo_van_purple.png`} />
                            </Avatar>
                        }
                        title={
                            <Fragment>
                                <Typography variant="body1" color="textPrimary" component="span">
                                    <b onClick={removeTrackDetailViewCallback}>{reportData.assetName}</b>
                                </Typography>
                                <br />
                                <Typography variant="body2" color="textSecondary" component="span">
                                    <b>{reportData.reportName} Report</b>
                                </Typography>

                            </Fragment>
                        }
                        subheader={
                            <Fragment>
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>Start: </b> {`${moment(reportData.reqBody.timeFrom).format('Do MMM YY hh:mm A')}`}
                                </Typography>
                                <br />
                                <Typography variant="subtitle2" color="textSecondary" component="span">
                                    <b>End: </b> {`${moment(reportData.reqBody.timeTo).format('Do MMM YY hh:mm A')}`}
                                </Typography>

                            </Fragment>
                        }
                        action={
                            reportData.status === 'submitted' ?
                                <Button
                                    startIcon={
                                        <CircularProgress color="secondary" size={20} />
                                    }
                                    onClick={() => { }}
                                    //onClick={deleteTrackCallback}
                                >
                                    <b><i><span style={{ color: 'red' }}>Building</span></i></b>
                                </Button>
                                :
                                reportData.status === 'nodata' ?
                                    <Button
                                        startIcon={
                                            <Icon
                                                path={mdiDelete}
                                                title="Delete Report"
                                                size={0.8}
                                                color="Red"
                                            />
                                        }
                                        onClick={deleteTrackCallback}
                                    >
                                        <b><i><span style={{ color: 'red' }}>No Data</span></i></b>
                                    </Button>
                                    :
                                    reportIsDetailView ?
                                        reportData.dataTable ?
                                            <Tooltip title="Close Report">
                                                <IconButton onClick={removeTrackDetailViewCallback} size="large">
                                                    <Icon
                                                        path={mdiCloseOctagon}
                                                        title="Close Report"
                                                        size={0.8}
                                                        color="Crimson"
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                            :
                                            <CircularProgress color="secondary" />
                                        :
                                        <Tooltip title="Show Report">
                                            <IconButton onClick={setTrackDetailviewCallback} size="large">
                                                <Icon
                                                    path={mdiEye}
                                                    title="Show Report"
                                                    size={0.8}
                                                    color="DodgerBlue"
                                                />
                                            </IconButton>
                                        </Tooltip>
                        }
                    />

                    {
                        reportData.status === 'ready' &&
                        <CardActions>
                            <ButtonGroup>
                                <Tooltip title="Download Excel">
                                    <IconButton
                                        size="small"
                                        onClick={() => dispatch(getExcel(reportID))}
                                    >
                                        <Icon
                                            path={mdiMicrosoftExcel}
                                            title="Download Excel"
                                            size={0.8}
                                            color="Green"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Download PDF">
                                    <IconButton
                                        size="small"
                                        onClick={() => dispatch(getPdf(reportID))}
                                    >
                                        <Icon
                                                path={mdiFilePdfBox}
                                            title="Download PDF"
                                            size={0.8}
                                            color="Crimson"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Email PDF Report">
                                    <IconButton
                                        size="small"
                                        onClick={() => setgetPdfFormOpen(true)}
                                    >
                                        <Icon
                                                path={mdiEmailArrowRight}
                                            title="Email PDF"
                                            size={0.8}
                                            color="Teal"
                                        />
                                    </IconButton>
                                </Tooltip>
                                {/*<Tooltip title="Share Report">
                                    <IconButton
                                        size="small"
                                        disabled
                                        onClick={() => { }}
                                    >
                                        <Icon
                                            path={mdiShareVariant}
                                            title="Share report"
                                            size={0.8}
                                            color="DodgerBlue"
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Save this Report">
                                    <IconButton
                                        size="small"
                                        disabled
                                        onClick={() => { }}
                                    >
                                        <Icon
                                            path={mdiContentSave}
                                            title="Save This Report"
                                            size={0.8}
                                            color="DarkMagenta"
                                        />
                                    </IconButton>
                    </Tooltip>*/}
                                <Tooltip title="Delete Report">
                                    <IconButton
                                        size="small"
                                        onClick={deleteTrackCallback}
                                    >
                                        <Icon
                                            path={mdiDelete}
                                            title="Delete Report"
                                            size={0.8}
                                            color="Red"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </ButtonGroup>

                        </CardActions>
                    }
                </Card>
                <GetPdfForm
                    getPdfFormOpen={getPdfFormOpen}
                    handleGetPdfFormClose={handleGetPdfFormClose}
                    reportIDs={[reportID]}
                />
            </div>
        );
    } else {
        return null;
    }
}

export default ReportListItem;